/**
 * Wraps << ... >> in text nodes with .tiempos-shortcode (Tiempos font).
 * Skips script/style/svg/pre/code/noscript and descendants.
 */
(function () {
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'TEMPLATE', 'NOSCRIPT']);

  function mustSkip(el) {
    let n = el;
    while (n && n.nodeType === 1) {
      const tag = n.tagName;
      if (SKIP_TAGS.has(tag)) return true;
      if (tag === 'SVG' || tag === 'PRE' || tag === 'CODE') return true;
      n = n.parentElement;
    }
    return false;
  }

  function processRoot(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const batch = [];
    let node;
    while ((node = walker.nextNode())) {
      if (!node.textContent || !node.textContent.includes('<<')) continue;
      if (mustSkip(node.parentElement)) continue;
      if (!/<<[\s\S]*?>>/.test(node.textContent)) continue;
      batch.push(node);
    }

    const className = document.body?.dataset.tiemposShortcodeClass || 'tiempos-shortcode';

    for (const textNode of batch) {
      const text = textNode.textContent;
      const parts = text.split(/<<(.*?)>>/gs);
      if (parts.length < 3) continue;
      const parent = textNode.parentNode;
      if (!parent) continue;

      const frag = document.createDocumentFragment();
      for (let i = 0; i < parts.length; i++) {
        if (i % 2 === 0) {
          if (parts[i]) frag.appendChild(document.createTextNode(parts[i]));
        } else {
          const span = document.createElement('span');
          span.className = className;
          span.textContent = parts[i];
          frag.appendChild(span);
        }
      }
      parent.replaceChild(frag, textNode);
    }
  }

  function run() {
    processRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const target = e.target;
    if (target && target.nodeType === 1) processRoot(target);
  });
})();
